import classNames from 'classnames';

function PageHeading({ title, subtitle, stretch, classes }) {
  return (
    <div className="bg-white px-4 md:px-3 py-8 sm:py-12 lg:py-16 lg:px-4">
      <div className={classNames('mx-auto text-center', { 'max-w-2xl': !stretch })}>
        <h2 className={classNames(classes?.title, 'text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-gray-900')}>{title}</h2>
        {subtitle && <p className={classNames(classes?.subtitle, 'mt-4 sm:mt-6 text-base sm:text-lg leading-7 sm:leading-8 text-gray-600')}>{subtitle}</p>}
      </div>
    </div>
  );
}

export default PageHeading;
